/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenterMachineData } from '../../models/work-center-machine-data';

export interface GetWorkCenterMachineDataList$Params {
}

export function getWorkCenterMachineDataList(http: HttpClient, rootUrl: string, params?: GetWorkCenterMachineDataList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkCenterMachineData>>> {
  const rb = new RequestBuilder(rootUrl, getWorkCenterMachineDataList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkCenterMachineData>>;
    })
  );
}

getWorkCenterMachineDataList.PATH = '/api/v1/WorkCenter/WorkCenterMachineDataList';
